import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Register all translations
import("./i18n/vi").then((m) => m.register());
import("./i18n/zh").then((m) => m.register());
import("./i18n/ja").then((m) => m.register());
import("./i18n/id").then((m) => m.register());
import("./i18n/th").then((m) => m.register());
import("./i18n/es").then((m) => m.register());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
